var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-auditor" },
    _vm._l(_vm.list, function(v, index) {
      return _c(
        "div",
        { key: index, staticClass: "item" },
        [
          index === 0
            ? [
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("i", {
                      staticClass: "icon",
                      class:
                        index === 0
                          ? "icon-audit-touxiang66dark"
                          : "icon-audit-touxiang66"
                    }),
                    v.selfFlag
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: v.userName + "(我)",
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "auditor" }, [
                                _vm._v(_vm._s(v.userName + "(我)"))
                              ])
                            ]
                          )
                        ]
                      : [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: v.userName,
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "auditor" }, [
                                _vm._v(_vm._s(v.userName))
                              ])
                            ]
                          )
                        ],
                    v.signStatus === -5
                      ? [
                          _c("div", { staticClass: "status text-color-red" }, [
                            _vm._v("已撤销")
                          ]),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(v.updateTime))
                          ])
                        ]
                      : _vm._e(),
                    v.signStatus === -6
                      ? [
                          _c("div", { staticClass: "status text-color-red" }, [
                            _vm._v("已失效")
                          ]),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(v.updateTime))
                          ])
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "status text-color-green" },
                            [_vm._v("发起申请")]
                          ),
                          _c("div", { staticClass: "time" }, [
                            _vm._v(_vm._s(v.createTime))
                          ])
                        ]
                  ],
                  2
                ),
                _vm._m(0, true)
              ]
            : [
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("i", {
                      staticClass: "icon",
                      class:
                        index === 0
                          ? "icon-audit-touxiang66dark"
                          : "icon-audit-touxiang66"
                    }),
                    v.selfFlag
                      ? [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: v.userName + "(我)",
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "auditor" }, [
                                _vm._v(_vm._s(v.userName + "(我)"))
                              ])
                            ]
                          )
                        ]
                      : [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: v.userName,
                                placement: "bottom"
                              }
                            },
                            [
                              _c("div", { staticClass: "auditor" }, [
                                _vm._v(_vm._s(v.userName))
                              ])
                            ]
                          )
                        ],
                    v.flowStatus === 1
                      ? _c("div", { staticClass: "status text-color-green" }, [
                          _vm._v("已同意")
                        ])
                      : _vm._e(),
                    v.flowStatus === 2
                      ? _c("div", { staticClass: "status text-color-red" }, [
                          _vm._v("已驳回")
                        ])
                      : _vm._e(),
                    v.flowStatus === 0
                      ? _c("div", { staticClass: "status" }, [_vm._v("未审批")])
                      : _vm._e(),
                    v.flowTime
                      ? _c("div", { staticClass: "time" }, [
                          _vm._v(_vm._s(v.flowTime))
                        ])
                      : _vm._e(),
                    v.refuseReason
                      ? _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [_vm._v(_vm._s(v.refuseReason))]
                          ),
                          _c("div", { staticClass: "reason" }, [
                            _vm._v("拒绝原因")
                          ])
                        ])
                      : _vm._e()
                  ],
                  2
                ),
                _vm.isOrder
                  ? _c("div", { staticClass: "audit-arrow-body" }, [
                      index !== _vm.list.length - 1
                        ? _c("i", { staticClass: "icon icon-audit-jiantou32" })
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "audit-arrow-body" }, [
      _c("i", { staticClass: "icon icon-audit-jiantou32" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74f83de4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f83de4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/auditDetail/index.vue
// module id = KiH9
// module chunks = 7 30 98 162